var Model = require("../types/Model.js");

var TIMEOUT = 1000 * 3; // 3 seconds

module.exports = Model({
	name: "pausescreen",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_timeout: null
});

function init(){
	this.push(false);
}

function uninit(){
	clearTimeout(this._timeout);
	this._timeout = null;
}

function triggers(){
	return {
		"pause": pause
	};
}

function pause(){
	if(this.data) return;
	this.push(true);
	this._timeout = setTimeout(clear.bind(this), TIMEOUT);
}

function clear(){
	if(!this.data) return;
	this.push(false);
	this._timeout = null;
}
